export interface ScreensDetails {
  Width: number;
  Height: number;
  Scaling: number;
  ColorDepth: number;
}

export interface HmrcHeader {
  PublicIP: string;
  DeviceID: string;
  ClientTimezone: string;
  ApplicationName: string;
  ScreensDetails?: ScreensDetails[];
  WindowSize?: ScreensDetails;
  UserAgent?: string;
}

const DEVICE_ID_KEY = 'hmrc_device_id';

export const getDeviceId = async (): Promise<string> => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};

export const getPublicIP = async (): Promise<string> => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('Failed to resolve public IP', error);
    return '';
  }
};

export const getTimezone = (): string => {
  const offsetMinutes = new Date().getTimezoneOffset();
  const totalMinutes = Math.abs(offsetMinutes);

  const sign = offsetMinutes <= 0 ? '+' : '-';
  const hours = String(Math.floor(totalMinutes / 60)).padStart(2, '0');
  const minutes = String(totalMinutes % 60).padStart(2, '0');

  return `UTC${sign}${hours}:${minutes}`;
};

export const getUserAgent = (): string => {
  return navigator.userAgent || '';
};

export class ScreenUtil {
  static getScreenDetails(): ScreensDetails[] {
    if (typeof window === 'undefined' || !window.screen) {
      return [];
    }

    const primaryScreen = window.screen;

    return [
      {
        Width: primaryScreen.width,
        Height: primaryScreen.height,
        Scaling: window.devicePixelRatio || 1,
        ColorDepth: primaryScreen.colorDepth || 24,
      },
    ];
  }
}

export class WindowUtil {
  static getWindowSize(): ScreensDetails {
    if (typeof window === 'undefined') {
      return {
        Width: 0,
        Height: 0,
        Scaling: 1,
        ColorDepth: 24,
      };
    }

    return {
      Width: window.innerWidth || 0,
      Height: window.innerHeight || 0,
      Scaling: window.devicePixelRatio || 1,
      ColorDepth: window.screen?.colorDepth || 24,
    };
  }
}

export const getHmrcHeader = async (): Promise<HmrcHeader> => ({
  PublicIP: await getPublicIP(),
  DeviceID: await getDeviceId(),
  ClientTimezone: getTimezone(),
  ApplicationName: 'generate.tax',
  ScreensDetails: ScreenUtil.getScreenDetails(),
  WindowSize: WindowUtil.getWindowSize(),
  UserAgent: getUserAgent(),
});
